import {getFetch,postFetch} from './httpConfig';

// 栏目列表
export function categorysortPage(data) {
  return getFetch(`cms/categorysort/web/page`, data);
}
// 新闻列表
export function articleList(data) {
  return getFetch(`cms/article/list`, data);
}
// 首页轮播图片
export function bannerList(data) {
  return getFetch(`cms/banner/web/page`, data);
}

// 新闻详情
export function articleDetail(data) {
  return getFetch(`cms/article/${data.id}`, data);
}
// 岗位列表
export function hrpostList(data) {
  return getFetch(`hr/hrpost/page`, data);
}
// 新增简历
export function hrVita(data) {
  return postFetch(`hr/vita`, data);
}
// 公司logo地址
export function memberPageList(data) {
  return getFetch(`cms/member/web/page`, data);
}
// 友情连接
export function websiteList(data) {
  return getFetch(`cms/link/website/page`, data);
}
// 公司介绍
export function agreementList(data) {
  return getFetch(`system/agreement/list`, data);
}
// 企业文化
export function policyList(data) {
  return getFetch(`system/policy/list`, data);
}
// 荣誉资质
export function aboutList(data) {
  return getFetch(`system/about/list`, data);
}